import { useGetCommunicationPreferenceQuery, usePatchCommunicationPreferenceMutation } from "../../../services/clientdetails";

const useCommunicationPreferences = (masterAccountId) => {
    const { data, error, isError, isFetching, isLoading, refetch } = useGetCommunicationPreferenceQuery({ masterAccountId });
    const [patch, { error: updateError, isError: isErrorUpdating, isLoading: isUpdating }] = usePatchCommunicationPreferenceMutation();

    const reload = (e) => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        refetch({ masterAccountId });
    };

    const update = (property, value) => {
        return new Promise((resolve, reject) => {
            const { communicationPreferenceId } = data || {};
            let operations = [
                { op: 'replace', path: `/${property}`, value: value }
            ];

            return patch({ masterAccountId, communicationPreferenceId, operations }).unwrap().then(
                r => resolve(r),
                e => reject(e)
            );
        });
    };

    return {
        data: data || null,
        error,
        isError,
        isErrorUpdating,
        isLoading: isFetching || isLoading,
        isUpdating,
        reload,
        updateError,
        update
    };
};

export default useCommunicationPreferences;